import { createFeature, createReducer, on } from '@ngrx/store';
import { Tax } from '../../entities/tax.entity';
import { taxActions, taxApiActions } from './tax.actions';

export interface TaxSate {
  loading: boolean;
  tax: Tax[];
  isReady: boolean;
}

export const initialTaxState: TaxSate = {
  loading: false,
  tax: undefined,
  isReady: false,
};

export const taxFeature = createFeature({
  name: 'tax',
  reducer: createReducer(
    initialTaxState,
    on(taxActions.loadTaxData, (state): TaxSate => ({ ...state, loading: true })),
    on(taxApiActions.loadTaxDataSuccess, (state, { tax }): TaxSate => ({ ...state, tax, loading: false, isReady: tax.length > 0 })),
    on(taxApiActions.loadTaxDataFailure, (state): TaxSate => ({ ...state, loading: false })),
  ),
});
